import React from 'react';
import { dummyClick } from '../utilities';

const Icon = ({ children, className, img, onClick }) => (
  <div className={`a-click-area pt12 cursor-pointer inline-block ${className}`} onClick={onClick}>
    <img className="grow" src={img} width="24" height="24" />
    {children}
  </div>
);

Icon.defaultProps = {
  className: 't-ph2-m t-ph1 ',
  img: '/images/sample_images/sample_jpg.jpg',
  onClick: dummyClick
};

const IconWithCounter = ({ count, ...rest }) => (
  <Icon {...rest}>
    <span>{count}</span>
  </Icon>
);

IconWithCounter.defaultProps = {
  count: 7777
};

export default Icon;
export { IconWithCounter };
